export const MULTIPLE = 'multiple';
export const SINGLE = 'single';
